export default __webpack_public_path__ + "9d4b81cc9e273bafb817aee4fb57651a.svg";